import { Reducer } from "redux";

import { ResendRegistrationActionDispatchTypes } from "../constants/MyAccount";
import { ResendRegistrationResponse } from "../models/api/MyAccount";
import { ResendRegistrationDispatchTypes } from "../models/dispatchTypes/MyAccount";

const initialState: ResendRegistrationResponse = {
  loading: false,
  response: false,
  error: null,
};

const ResendRegistrationReducer: Reducer<ResendRegistrationResponse, ResendRegistrationDispatchTypes> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case ResendRegistrationActionDispatchTypes.RESEND_REGISTRATION_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case ResendRegistrationActionDispatchTypes.RESEND_REGISTRATION_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case ResendRegistrationActionDispatchTypes.RESEND_REGISTRATION_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case ResendRegistrationActionDispatchTypes.RESEND_REGISTRATION_RESET: {
      return initialState;
    }
  }
  return state;
};

export default ResendRegistrationReducer;
